import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Typography } from '@mui/material';
import { getLogin, getTokenVerify } from 'redux/actions/UserLogin';
import CommonForm from 'components/commonForm/CommonForm';
import Loader from 'components/loader/Loader';
import Otp from 'pages/otp/Otp'
import loginHand from 'assets/images/login_hand.png';
import { companyDetailsEnum } from 'utils/companyDetails';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searhParams] = useSearchParams()
  const magicToken = searhParams?.get('magicToken')
  const userLogin = useSelector((state) => state);
  const isLoader = userLogin?.userLogin?.loading;
  const [onOtp, setOnOtp] = useState(false)

  //if we click on switch functionality b2b to b2c then this function will be call
  useEffect(() => {
    if(magicToken){
      dispatch(getTokenVerify(magicToken))
    }
  }, [magicToken]);

  useEffect(() => {
    setOnOtp(false);
  }, []);

  const handleredirect = () => {
    navigate('/signup')
  }

  const onOtpPage = (val) => {
    setOnOtp(val)
  }
  
  const loginFormSubVendor = [
    {
      placeholder: 'Enter your Email ID or Mobile Number',
      required: true,
      type: 'text',
      name: 'mobileOrEmail',
      label: 'Email ID or Mobile number',
      star: '*',
      countrycode: false,
    },
  ];

  const onLogin = (data, code) => {
    localStorage.clear();
    const loginPayload = {
      userDetails: {
        platform: 'AdminApp',
        mobileOrEmail: data.mobileOrEmail,
        countryCode: data?.countryCode || '+91',
      },
      actionType: "login"
    }
    // dispatchEvent(call redux function: action -> saga -> reducer (update the store)
    dispatch(getLogin(loginPayload, navigate, setOnOtp));
  };

  return (
    <div>
      {onOtp === false &&<Box sm={{ flexGrow: 1 }} className="mobileRes loginMain">
      {magicToken ? <Loader/> : <Grid container>
          {/* ---login Part--- */}
          <Grid item sm={6}>
            {/* ---login nav--- */}
            <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex' },
                    alignItems: 'center',
                  }}
                  className="positionAbsolute"
                >
                  <img src={companyDetailsEnum?.companyLogoDark} className="logoImg" alt="otplogo" />
                </Box>
            {/* ---login input type--- */}
            <div className="loginInput mobileBg">
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                rowSpacing={4}
              >
                <Grid item sm={10} className='textCenter'>
                  <img src={loginHand} alt="hand" />
                  <Typography className="fontBold font36 colorBlue">
                  Let's get started as
                  </Typography>
                  <Typography className="colorYellow font36 fontBold">
                  Sub-Vendor
                  </Typography>
                </Grid>
                <Grid item sm={7}>
                  <CommonForm
                    formData={loginFormSubVendor}
                    button={'Login'}
                    onSubmittBtn={onLogin}
                    loading={isLoader}
                  />
                </Grid>
              </Grid>
            <Typography className="colorGrey font18 fontNormal marginTop">Don't have an account ?<span className="colorBlue cursor" onClick={handleredirect}> Signup now</span></Typography>
            </div>
          </Grid>
          {/* ---Image Part--- */}
          <Grid item sm={6} sx={{ display: { xs: 'none', sm: 'flex' }}} className="bgImage">
            <div className="loginBgImg"></div>
          </Grid>
        </Grid>}
      </Box>}
      {onOtp&&<Otp onOtpPage={onOtpPage}/>}
    </div>
  );
}
